/**
 * Caching configuration for the address reference data (regions, cities).
 *
 * These lists change rarely, so we cache them in IndexedDB and serve them cache-first: while the
 * cached value is still fresh (younger than its TTL) we skip the network entirely; once it is older
 * than the TTL we refetch and overwrite the cache. See `lib/indexedDbCache` and `api/accountApi`.
 */

import { MS_IN_DAY } from '../time';

/**
 * How long a cached list stays "fresh" before we refetch it.
 * Cities change more often than regions, so they get a shorter TTL.
 */
export const ADDRESS_CACHE_TTL = {
    REGIONS: 14 * MS_IN_DAY,
    CITIES: 3 * MS_IN_DAY,
    COUNTRIES: 14 * MS_IN_DAY,
};

/**
 * Cache keys for the IndexedDB store. Countries are a single global list (static key); regions are
 * keyed by country; cities by country + region.
 */
export const ADDRESS_CACHE_KEY = {
    countries: 'countries',
    regions: (PK_Country) => `regions:${PK_Country}`,
    cities: (PK_Country, PK_Region) => `cities:${PK_Country}:${PK_Region}`,
};

/**
 * Field names that hold the list in each address endpoint response payload (e.g. `response.data.Country`).
 */
export const ADDRESS_RESPONSE_KEY = {
    COUNTRIES: 'Country',
    REGIONS: 'Regions',
    CITIES: 'Cities',
};
